import React from 'react';
import { AlertTriangle, Sparkles } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import { commonScams } from '../../data/education/scams';
import { useCommonScams } from '../../hooks/useEducationContent';

export function CommonScams() {
  const { data: aiScams, isLoading: scamsLoading } = useCommonScams();

  const displayScams = aiScams && aiScams.length > 0 ? aiScams : commonScams;
  const isAIContent = aiScams && aiScams.length > 0;

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="relative h-48">
        <img
          src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43"
          alt="Warning about financial scams and fraud"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-red-900/80 to-red-800/60" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white">
            <AlertTriangle className="h-12 w-12 mx-auto mb-2" />
            <h2 className="text-2xl font-bold">Common Scams to Avoid</h2>
          </div>
        </div>
      </div>
      <div className="p-6">
        {isAIContent && (
          <div className="mb-4 flex items-center gap-2 text-sm text-red-600 bg-red-50 px-3 py-2 rounded-lg">
            <Sparkles className="h-4 w-4" />
            <span>AI-generated alerts about current scams in Nigerian forex market</span>
          </div>
        )}

        {scamsLoading ? (
          <div className="grid gap-6">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="border-l-4 border-red-300 pl-4 animate-pulse">
                <div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-full mb-1"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                <div className="h-4 bg-red-100 rounded w-2/3"></div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid gap-6">
            {displayScams.map((scam, index) => (
              <div key={index} className="border-l-4 border-red-500 pl-4 bg-red-50 p-4 rounded-r-lg">
                <h3 className="font-semibold text-lg mb-2 text-red-900">{scam.title}</h3>
                <p className="text-gray-700 mb-2">{scam.description}</p>
                <div className="flex items-start gap-2 mt-3">
                  <AlertTriangle className="h-4 w-4 text-red-600 mt-0.5 flex-shrink-0" />
                  <p className="text-red-600 text-sm font-medium">{scam.warning}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}